import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { 
  Settings, 
  CreditCard, 
  Package, 
  QrCode, 
  ScanLine,
  MessageSquare,
  LayoutDashboard,
  Palette
} from 'lucide-react';

const AdminNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  const navItems = [
    { path: '/admin', label: 'Dashboard', icon: LayoutDashboard },
    { path: '/admin/products', label: 'Shop & Orders', icon: Package },
    { path: '/admin/card-designer', label: 'Card Designer', icon: Palette },
    { path: '/admin/nfc', label: 'NFC Cards', icon: QrCode },
    { path: '/admin/cards', label: 'All Cards', icon: CreditCard },
    { path: '/admin/scanned-contacts', label: 'Scanned Contacts', icon: ScanLine },
    { path: '/admin/chat-support', label: 'Chat Support', icon: MessageSquare },
  ];

  return (
    <div className="bg-white border-b border-gray-200 sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-1 py-2 overflow-x-auto scrollbar-hide">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = currentPath === item.path;
            
            return (
              <Button
                key={item.path}
                variant={isActive ? 'default' : 'ghost'}
                size="sm"
                onClick={() => navigate(item.path)}
                className={`whitespace-nowrap flex-shrink-0 ${
                  isActive 
                    ? 'bg-amber-600 hover:bg-amber-700 text-white' 
                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                }`}
              >
                <Icon className="w-4 h-4 mr-2" />
                {item.label}
              </Button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AdminNav;
